module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-it\" viewBox=\"0 0 512 512\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fff\" d=\"M0 0h512v512H0z\"/>\n    <path fill=\"#009246\" d=\"M0 0h170.7v512H0z\"/>\n    <path fill=\"#ce2b37\" d=\"M341.3 0H512v512H341.3z\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./public/img/flags/1x1/it.svg
// module id = TM0E
// module chunks = 5